import { PATH } from '@/screens/Category';

import {
  CLOSET_PATH,
  FLOOR_PATH,
  HANDING_PATH,
  LED_MIRRORS_PATH,
  MIRROR_CABINETS_PATH,
  MIRRORS_PATH,
  PEDESTAL_PATH,
  UNDER_WASHING_MACHINE_PATH,
  WITH_SINK
} from '@shared/constants/catalog';

import icon1_h from '../../images/1-h.svg';
import icon1_1_h from '../../images/1.1-h.svg';
import icon1_1 from '../../images/1.1.svg';
import icon1_2_h from '../../images/1.2-h.svg';
import icon1_2 from '../../images/1.2.svg';
import icon1_3_h from '../../images/1.3-h.svg';
import icon1_3 from '../../images/1.3.svg';
import icon1 from '../../images/1.svg';
import icon2_h from '../../images/2-h.svg';
import icon2 from '../../images/2.svg';
import icon3_h from '../../images/3-h.svg';
import icon3_1_h from '../../images/3.1-h.svg';
import icon3_1 from '../../images/3.1.svg';
import icon3_2_h from '../../images/3.2-h.svg';
import icon3_2 from '../../images/3.2.svg';
import icon3 from '../../images/3.svg';
import img3_1 from '../../images/shkaf-napolnyi.png';
import img3_3 from '../../images/shkaf-pod-stiralku.png';
import img3_2 from '../../images/shkaf-podvesnoi.png';
import img1_3 from '../../images/tumba_pod_stiralku.png';
import img1_1 from '../../images/tumba-napolnaya.png';
import img1_2 from '../../images/tumba-navesnaya.jpg';
import img1_4 from '../../images/tumba-s-rakovinoi.png';
import img2_1 from '../../images/zerkala-s-podsvetkoi.png';
import img2_2 from '../../images/zerkalnui-shkaf.png';
import { CategoryLinkType, SubCategoryLinkType } from '../types/categoryLink';

export const categories: CategoryLinkType[] = [
  {
    url: PATH[PEDESTAL_PATH].url,
    label: 'Тумбы',
    value: PEDESTAL_PATH,
    image: img1_1,
    iconDefault: icon1,
    iconHover: icon1_h
  },
  {
    url: PATH[MIRRORS_PATH].url,
    label: 'Зеркала',
    image: img2_1,
    value: MIRRORS_PATH,
    iconDefault: icon2,
    iconHover: icon3_h
  },
  {
    url: PATH[CLOSET_PATH].url,
    label: 'Шкафы',
    value: CLOSET_PATH,
    image: img3_1,
    iconDefault: icon3,
    iconHover: icon2_h
  }
];

export const subCategories: Record<string, SubCategoryLinkType[]> = {
  [PEDESTAL_PATH]: [
    {
      url: PATH[PEDESTAL_PATH].subcategories[FLOOR_PATH].url,
      label: 'Напольные',
      image: img1_1,
      iconDefault: icon1,
      iconHover: icon1_h
    },
    {
      url: PATH[PEDESTAL_PATH].subcategories[HANDING_PATH].url,
      label: 'Подвесные',
      image: img1_2,
      iconDefault: icon1_1,
      iconHover: icon1_1_h
    },
    {
      url: PATH[PEDESTAL_PATH].subcategories[UNDER_WASHING_MACHINE_PATH].url,
      label: 'Под стиральную машину',
      image: img1_3,
      iconDefault: icon1_2,
      iconHover: icon1_2_h
    },
    {
      url: PATH[PEDESTAL_PATH].subcategories[WITH_SINK].url,
      label: 'С раковиной',
      image: img1_4,
      iconDefault: icon1_3,
      iconHover: icon1_3_h
    }
  ],
  [MIRRORS_PATH]: [
    {
      url: PATH[MIRRORS_PATH].subcategories[LED_MIRRORS_PATH].url,
      label: 'Зеркала с подсветкой',
      image: img2_1,
      iconDefault: icon3_1,
      iconHover: icon3_1_h
    },
    {
      url: PATH[MIRRORS_PATH].subcategories[MIRROR_CABINETS_PATH].url,
      label: 'Зеркальные шкафы',
      image: img2_2,
      iconDefault: icon3_2,
      iconHover: icon3_2_h
    }
  ],
  [CLOSET_PATH]: [
    {
      url: PATH[CLOSET_PATH].subcategories[FLOOR_PATH].url,
      label: 'Напольные',
      image: img3_1,
      iconDefault: icon1,
      iconHover: icon1_h
    },
    {
      url: PATH[CLOSET_PATH].subcategories[HANDING_PATH].url,
      label: 'Подвесные',
      image: img3_2,
      iconDefault: icon1_1,
      iconHover: icon1_1_h
    },
    {
      url: PATH[CLOSET_PATH].subcategories[UNDER_WASHING_MACHINE_PATH].url,
      label: 'Под стиральную машину',
      image: img3_3,
      iconDefault: icon1_2,
      iconHover: icon1_2_h
    }
  ]
};
